/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from "react";
import Header from "./components/Header";
// import Footer from "./components/Footer";
import MainSection from "./components/MainSection";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import {
  checkCampaignStatus,
  checkVoteOfUser,
  getAnonymousAsync,
  getProfileMBFAsync,
  getListSingers,
  getProfileAsync,
} from "./reducers/user";
import { openPopup } from "./reducers/popup";
import ModalHandler from "./components/Modal/ModalHandler";
import Cookie from "react-cookies";
import { KEY, remove, save } from "./cookie";
import { POPUP_NAME, STATUS_CAMPAIGN } from "./utilities/constants";
import { sendToast } from "./utilities/utils";

function App() {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state?.user?.profile);
  const profileMBF = useSelector((state) => state?.user?.profileMBF);
  const anonymous = useSelector((state) => state?.user?.anonymous);
  const statusCampaign = useSelector((state) => state?.user?.statusCampaign);

  const [isLogged, setIsLogged] = useState(false);

  useEffect(() => {
    dispatch(checkCampaignStatus());
    // dispatch(openPopup({ name: POPUP_NAME.INTRO_ADS }));
  }, []);

  useEffect(() => {
    if (statusCampaign === STATUS_CAMPAIGN.NOT_STARTED) {
      dispatch(openPopup({ name: POPUP_NAME.SHOW_NOT_STARTED }));
      return;
    }
    if (statusCampaign === STATUS_CAMPAIGN.ENDED) {
      dispatch(openPopup({ name: POPUP_NAME.SHOW_ENDED }));
      dispatch(getListSingers());
      return;
    }
    if (statusCampaign === STATUS_CAMPAIGN.RUNNING) {
      dispatch(getListSingers());
    }
  }, [statusCampaign]);

  useEffect(() => {
    if (
      profile?.id &&
      profile?.accessToken &&
      statusCampaign === STATUS_CAMPAIGN.RUNNING
    ) {
      dispatch(checkVoteOfUser(profile?.accessToken));
    }
  }, [profile, statusCampaign]);

  useEffect(() => {
    if (profile === null) {
      handleGetProfile();
    } else if (!profile?.id) {
      dispatch(getAnonymousAsync());
      remove(KEY.ACCESS_TOKEN);
      removeToken();
    } else if (profile?.id && profile?.accessToken) {
      save(KEY.ACCESS_TOKEN, profile?.accessToken);
      remove(KEY.ANONYMOUS_TOKEN);
      remove(KEY.MBF_ACCESS_TOKEN);
      removeToken();
    }
  }, [profile]);

  useEffect(() => {
    if (profileMBF === null) {
      handleGetProfile();
    } else if (
      !profileMBF?.result?.access_token &&
      !Cookie.load(KEY.MBF_ACCESS_TOKEN)
    ) {
      dispatch(getAnonymousAsync());
      remove(KEY.MBF_ACCESS_TOKEN);
      removeToken();
    } else if (profileMBF?.result?.access_token) {
      save(KEY.MBF_ACCESS_TOKEN, profileMBF?.result?.access_token);
      dispatch(getProfileAsync(profileMBF?.result?.access_token));
      setIsLogged(true);

      remove(KEY.ANONYMOUS_TOKEN);
      remove(KEY.ACCESS_TOKEN);
      removeToken();
    }
    return () => {};
  }, [profileMBF]);

  useEffect(() => {
    if (isLogged) {
      sendToast("Đăng nhập thành công");
    }
  }, [isLogged]);

  useEffect(() => {
    if (anonymous?.access_token) {
      Cookie.save(KEY.ANONYMOUS_TOKEN, anonymous?.access_token);
    }
  }, [anonymous]);

  const removeToken = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("t") || queryParams.get("t_mbf");

    if (token) {
      if (typeof window.history !== "undefined") {
        window.history.replaceState(null, null, "/");
      }
    }
  };

  const handleGetProfile = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("t");
    const mbf_token = queryParams.get("t_mbf");
    const accessToken = token || Cookie.load(KEY.ACCESS_TOKEN);
    const mbfAccessToken = mbf_token || Cookie.load(KEY.MBF_ACCESS_TOKEN);
    if (mbfAccessToken) {
      dispatch(getProfileMBFAsync(mbfAccessToken));
    } else if (accessToken) {
      dispatch(getProfileAsync(accessToken));
    } else {
      dispatch(getAnonymousAsync());
    }
  };

  return (
    <div className="relative flex flex-col w-full h-full modal-bg scrollbar">
      <Header />
      <MainSection />
      {/* <Footer /> */}
      <ModalHandler />
      <ToastContainer
        autoClose={3000}
        hideProgressBar
        closeOnClick
        theme="dark"
      />
    </div>
  );
}

export default App;
